import React, { useState } from "react";
import {
  BarMobile,
  BarDevice
} from "../../styles/Docs/DocsToolbar.styled";
import { Counterparties } from "./Counterparties";
import { Btn } from "../../styles/Button.styled";
import MediaQuery from "react-responsive";



export default function AdminDocCounterparties(props: AdminDocCounterpartiesProps) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  return (
    <>
    <MediaQuery maxWidth={991}>
      <BarMobile>
        <Btn
            type="button"
            onClick={handleOpen}
            bgcolor="red"
            // $marginTop="0"
            // $height="46px"
            $width="100%"
            disabled={props.doc && props.doc.state !== "success"}
            $background= "RED"
          >
          Переглянути підписантів
        </Btn>
        <Counterparties
                open={open}
                handleClose={handleClose}
                counterparties={props.doc.counterparties}
                signatures={props.doc.signatures}
              />
      </BarMobile>
    </MediaQuery>

    <MediaQuery minWidth={992}>
      <BarDevice>
        <Btn
            type="button"
            onClick={handleOpen}
            bgcolor="red"
            // $marginTop="0"
            // $height="46px"
            $width="100%"
            disabled={props.doc && props.doc.state !== "success"}
            $background= "RED"
          >
          Переглянути підписантів
        </Btn>
        <Counterparties
                open={open}
                handleClose={handleClose}
                counterparties={props.doc.counterparties}
                signatures={props.doc.signatures}
              />
      </BarDevice>
    </MediaQuery>
    </>
  );
}
